import * as Form from '../../components/form'
import * as RasaInput from '../../components/rasa-input'
import * as Types from './types'

export const FETCH_LEAD_POSTS = 'FETCH_LEAD_POSTS'
export const ADD_LEAD_POST = 'ADD_LEAD_POST'
export const UPDATE_LEAD_POST = 'UPDATE_LEAD_POST'
export const RESET_REORDERED_LEAD_POST = 'RESET_REORDERED_LEAD_POST'
export const SAVE_REORDERED_LEAD_POST = 'SAVE_REORDERED_LEAD_POST'

export const SERVER_RESOURCE = '/lead-posts'
export const FEATURED_POST_FORM = 'FEATURED_POST_FORM'

export const TITLE = 'title'

export const UPLOAD_IMAGE_LEAD_POST = 'UPLOAD_IMAGE_LEAD_POST'

export const FeatureTypes = {
  Lead: 'Lead',
  Sponsored: 'Sponsored',
}

export const FormFieldNames = {
  CategoryTypeId: 'category_type_id',
  Description: 'description',
  EndDate: 'end_date',
  FeatureType: 'feature_type',
  ImageUrl: 'image_url',
  Rank: 'rank',
  SiteName: 'site_name',
  StartDate: 'start_date',
  Title: 'title',
  Url: 'url',
}

export const emptyFormField: Types.FormFields = {
  category_type_id: null,
  description: '',
  end_date: null,
  feature_type: FeatureTypes.Lead,
  image_url: '',
  rank: null,
  site_name: '',
  start_date: null,
  title: '',
  url: '',
}

export const emptyModalData: Types.ModalValidation = {
  showAddValidation: false,
}

export const FormValidators: Form.FormValidators = {
  [FormFieldNames.FeatureType]: RasaInput.validatePresent,
  [FormFieldNames.ImageUrl]: RasaInput.validateOptionalForgivingUrl,
  [FormFieldNames.Url]: RasaInput.validateForgivingUrl,
}



// WEBPACK FOOTER //
// ./src/pages/lead-posts/constants.ts